import React, { ReactNode } from 'react';
import { Formik, Form, FieldAttributes } from 'formik';
import { Box as Wrapper } from '@tonic-ui/react';

type FormContainerProps = {
  id: string;
  initialValues: Record<string, unknown>;
  enableReinitialize: boolean;
  validateOnBlur?: boolean;
  validateOnChange?: boolean;
  validateOnMount?: boolean;
  submitAction: (formPayload: Record<string, unknown>) => Promise<unknown> | void;
  customValidation: Record<string, any>;
  children: ReactNode;
} & FieldAttributes<Record<string, unknown>>;

const FormContainer = ({
  id,
  initialValues = {},
  customValidation,
  enableReinitialize,
  validateOnBlur = false,
  validateOnChange = false,
  validateOnMount = false,
  submitAction,
  children,
}: FormContainerProps): JSX.Element => {
  return (
    <Wrapper className={`c1c_${id}_wrapper`}>
      <Formik
        initialValues={initialValues}
        enableReinitialize={enableReinitialize}
        validationSchema={customValidation}
        validateOnChange={validateOnChange}
        validateOnBlur={validateOnBlur}
        validateOnMount={validateOnMount}
        onSubmit={(data, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          submitAction({ ...data, setSubmitting, resetForm });
        }}
      >
        {({ handleSubmit }) => (
          <Form id={`c1c_form_${id}`} data-id={id} data-ux-id={id} onSubmit={handleSubmit}>
            {children}
          </Form>
        )}
      </Formik>
    </Wrapper>
  );
};

FormContainer.displayName = 'FormContainer';

export default FormContainer;
